<section class="login-page">
  <form class="login-panel" (ngSubmit)="seConnecter()">
    <img src="img/analytics_couleur.png" alt="Analytics" class="login-logo" />

    <div class="login-heading">
      <span class="material-symbols-outlined">lock</span>
      <h1>Connexion</h1>
    </div>

    <label>
      Identifiant
      <input
        name="login"
        type="text"
        inputmode="email"
        autocomplete="username"
        [(ngModel)]="login"
        [disabled]="chargement()"
        required
      />
    </label>

    <label>
      Mot de passe
      <input
        name="password"
        type="password"
        autocomplete="current-password"
        [(ngModel)]="password"
        [disabled]="chargement()"
        required
      />
    </label>

    @if (erreur()) {
      <p class="login-error">{{ erreur() }}</p>
    }

    <button type="submit" [disabled]="chargement() || !login.trim() || !password">
      {{ chargement() ? 'Connexion...' : 'Se connecter' }}
    </button>
  </form>
</section>
